export default "__VITE_ASSET__CED14Z1o__"